<div class="flex flex-row justify-center items-center">
  <div class="w-4/5">
    <div class="flex justify-center">
      <div class="flex flex-col gap-10 main-container">
        <div class="flex flex-col gap-6">
          <div class="flex flex-col gap-2">
            <div id="set-mobile-app-title" class="dcp-h2">
              1. Download the App to Your Mobile Device
            </div>
            <p id="authenticator-app-info" class="dcp-body">
              Download and install the Google Authenticator App, available for iOS and Android.
            </p>
          </div>
          <div class="flex flex-col gap-4 md:gap-2">
            <div class="flex flex-row justify-start items-center">
              <p id="authenticator-app-text" class="dcp-h5 dcp-h5-bold">Download Google Authenticator</p>
            </div>
            <div class="flex flex-col md:flex-row justify-start items-center gap-8">
              <a id="ios-app-store-link" class="dcp-focus-outline" href="https://apps.apple.com/us/app/google-authenticator/id388497605/" target="_blank" tabindex="0">
                <img id="ios-app-store-img" class="download-img app-store" src="../../../../../assets/img/download_app_store.png" alt="Download from App Store.">
              </a>
              <a id="android-app-store-link" class="dcp-focus-outline" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en" target="_blank"
                 tabindex="0">
                <img id="android-app-store-img" class="download-img google-play" src="../../../../../assets/img/download_google_play.png" alt="Download from Google Play.">
              </a>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-6">
          <div class="flex flex-col gap-2">
            <div id="authenticator-app-second-step" class="dcp-h2">
              2. Set Up the App on Your Mobile Device
            </div>
            <p id="authenticator-app-second-step-info" class="dcp-body">
              Open the application on your mobile device and follow the on-screen instructions to scan or manually enter the code below.
            </p>
          </div>

          <div class="flex flex-row justify-center items-center">
            <p id="mobile-app-code" class="dcp-h5 gray-color w-full max-wide-content dcp-body-bold" spellcheck="false" aria-label="The code for your mobile device.">
              {{ secret }}
            </p>
          </div>

          <div class="flex flex-row justify-center items-center">
            <qr-code [lightColor]="'#ecedf0'" [value]="qrValue" aria-hidden="false" aria-label="Image of QR code."></qr-code>
          </div>
        </div>
        <div class="flex flex-col gap-4">
          <div class="flex flex-row justify-center items-center">
            <div class="continue-button-width">
              <pin-button buttonId="mfa-continue-button" buttonType="button" buttonStyle="filled" (buttonClick)="continue()">CONTINUE</pin-button>
            </div>
          </div>
          <div class="flex flex-col gap-2 md:gap-4 justify-center items-center">
            <p id="footer-question" class="dcp-body">Having trouble?</p>
            <pin-button id="back-to-setup-button" buttonStyle="link" customClass="pb-1!" buttonType="button" [redirectUrl]="internalRoutes.SETUP_SECURITY_TOKEN" [queryParams]="currentQueryParams">
	            Try a different verification method.
            </pin-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loadingQR) {
  <div class="pin-spinner fullscreen">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
}
